import { render, staticRenderFns } from "./RoomSetting.vue?vue&type=template&id=7c104a9a&scoped=true"
import script from "./RoomSetting.vue?vue&type=script&lang=js"
export * from "./RoomSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c104a9a",
  null
  
)

export default component.exports